import React from "react";

import LocationMap from "./widgets/LocationMap";
import SearchBar from "./widgets/SearchBar";
import Carcategoryslider from "./widgets/Carcategoryslider";
import StationsList from "./widgets/StationList";
import VehicleList from "./widgets/VehicleList";

function App(props: any) {
  let content;

  switch (props.symbol) {
    case "locationmap":
      content = <LocationMap symbol={props.symbol} />;
      break;
    case "searchbar":
      content = (
        <SearchBar
          useinputsearch={props.dataset.useinputsearch}
          symbol={props.symbol}
        />
      );
      break;
    case "carcategoryslider":
      content = <Carcategoryslider symbol={props.symbol} />;
      break;
    case "vehiclelist":
      content = <VehicleList special={props.dataset.specialcar} />;
      break;
    case "stationlist":
      content = (
        <StationsList
          symbol={props.symbol}
          type={props.dataset.type}
          detailpage={props.dataset.detailpage}
        />
      );
      break;
    default:
      break;
  }

  return <div>{content}</div>;
}

export default App;
